<!--
 * 二次封装ant-design的a-range-picker组件
 * 可通过 start 和 end 分别绑定值
 * <lin-range-picker
      valueFormat="YYYY-MM-DD"
      :start.sync="searchForm.createDateStart"
      :end.sync="searchForm.createDateEnd"
      @change="fetchData(true)"
    />
-->
<template>
  <a-range-picker v-bind="$attrs" v-on="$listeners" v-model="value"></a-range-picker>
</template>

<script>
export default {
  name: "LinRangePicker",
  props: {
    start: {},
    end: {}
  },
  data() {
    return {};
  },
  computed: {
    value: {
      get() {
        return [this.start, this.end];
      },
      set(val) {
        this.$emit("update:start", val[0]);
        this.$emit("update:end", val[1]);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
